import {Helpers} from "../helpers/helpers";
import * as _ from "lodash";
import {MAP_STYLES} from "../locator";
import {SuccessStory} from "../pages/success-story-list";
import {MobileHelpers} from "../helpers/mobile-helpers";
import {MarkerClusterer, MarkerClustererOptions, Renderer} from "@googlemaps/markerclusterer";
import {SiteHelpers} from "../helpers/site-helpers";

export class SuccessStoriesMap {
	private wrapper: HTMLElement;
	private mapElement: HTMLElement;
	private map: google.maps.Map;
	private markers: any[];
	private infoWindow: google.maps.InfoWindow;
	private mapIdleDebounce: (() => void);
	private skipNextIdleEvent: any;
	private lastSearchCoords: google.maps.LatLng;
	private countryFilterDropDown: HTMLSelectElement;
	private stateFilterDropdown: HTMLSelectElement;
	private mapIcons: Map<string, string>;
	private markerCluster: MarkerClusterer;
	
	public constructor() {
		this.wrapper = document.querySelector('.success-stories-section .icon-map-wrapper') as HTMLElement;
		if (!this.wrapper) return;
		
		this.mapElement = this.wrapper.querySelector('.map') as HTMLElement;
		this.countryFilterDropDown = document.querySelector(".success-stories-section .country-filter") as HTMLSelectElement;
		this.stateFilterDropdown = document.querySelector(".success-stories-section .state-filter") as HTMLSelectElement;		
		this.mapIcons = new Map(); 
		
		document.querySelectorAll('.map-icons li .icon').forEach((iconEl :HTMLElement) => {
			const iconName = iconEl.dataset.iconname;
			const svg = iconEl.innerHTML;
			this.mapIcons.set(iconName,svg);			
		})		
		this.initMap();	
		this.initMobileMapButton();	
		
	}
	
	private initMobileMapButton() {
		const listView = document.querySelector('.success-stories-list') as HTMLElement;
		const mapButton = document.querySelector('.fixed-map-button');
		mapButton.addEventListener('click', () =>{
			Helpers.scrollToElement(this.mapElement);
		})
		window.addEventListener("scroll",
			() => {

				if (Helpers.elementIsInView(listView)) {
					mapButton.classList.add('open');
				} else {
					mapButton.classList.remove('open');
				}

			});
	}
	
	private initMap() {
		let mapCenter = new google.maps.LatLng(37.09024, -95.712891);
	

		const options: google.maps.MapOptions = {
			zoom: 5,
			center: mapCenter, // US center point
			scrollwheel: false,
			streetViewControl: false,
			mapTypeControl: false,
			styles: MAP_STYLES
		};

		this.map = new google.maps.Map(this.mapElement, options);

		this.markers = [];
		this.infoWindow = new google.maps.InfoWindow();

		this.lastSearchCoords = mapCenter;
		this.mapIdleDebounce = _.debounce(() => {
			if (this.skipNextIdleEvent) {
				this.skipNextIdleEvent = false;
				return;
			}

			const distanceFromLastSearchMeters = google.maps.geometry.spherical.computeDistanceBetween(this.map.getCenter(), this.lastSearchCoords);
			const mapBounds = this.map.getBounds();
			const mapDiagonalDistance = google.maps.geometry.spherical.computeDistanceBetween(mapBounds.getNorthEast(), mapBounds.getSouthWest());
			const mapZoomLevel = this.map.getZoom();
			if (mapZoomLevel < 8) {
				this.hideSearchAreaButton();
			} else if (distanceFromLastSearchMeters > mapDiagonalDistance * 0.25) {
				this.showSearchAreaButton();
			}



		}, 500);

		this.map.addListener("idle", () => {
			//this.mapIdleDebounce();
		});
	}

	public updateLocationPoints(results: SuccessStory[]){
		this.clearResults();
		const latLngResults = results.filter(r=>r.latitude).length;
		if (results.length === 0 || latLngResults == 0) {
			this.map.setCenter(this.lastSearchCoords);
			this.map.setZoom(3);
			//this.showNoResultsMessage();
			return;
		}

		//this.hideNoResultsMessage();

		const bounds = new google.maps.LatLngBounds();
		
		for (let index = 0; index < results.length; index++) {
			const story = results[index];

			if (!story.latitude) continue;
			const markerPosition = new google.maps.LatLng(story.latitude, story.longitude);
			bounds.extend(markerPosition);

			const default_svg = `
							<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
								<defs>
									<style>
										.cls-1{fill:#1f275d}
									</style>
								</defs>
								<path class="cls-1" d="M40.94 37.63a1.81 1.81 0 0 0 1.81-1.8v-6.36H17.81v6.36a1.81 1.81 0 0 0 1.81 1.8Zm-4-6.28a2.16 2.16 0 1 1-2.16 2.16 2.16 2.16 0 0 1 2.12-2.16Zm-13.3 0a2.16 2.16 0 1 1-2.16 2.16 2.16 2.16 0 0 1 2.12-2.16Z"/>
								<path class="cls-1" d="M30 0a30 30 0 1 0 30 30A30 30 0 0 0 30 0Zm15.92 48.8-.75-1.3H14.9l-.84 1.33-1.7-1.06 5.43-8.63a3.79 3.79 0 0 1-2-3.31V16.37a5.68 5.68 0 0 1 5.68-5.67h17.61a5.67 5.67 0 0 1 5.67 5.67v19.46a3.79 3.79 0 0 1-2.07 3.36l5 8.61Z"/>
								<path class="cls-1" d="M39.08 12.7H21.49a3.67 3.67 0 0 0-3.67 3.46h24.92a3.66 3.66 0 0 0-3.66-3.46ZM18.62 41.57h23.12l-1.11-1.94H19.84l-1.22 1.94zM17.37 43.57l-1.22 1.93h27.87l-1.12-1.93H17.37zM31.28 18.16h11.47v9.31H31.28zM17.81 18.16h11.47v9.31H17.81z"/>
							</svg>`;

			
			let svg = default_svg;
			const svgLookup = this.mapIcons.get(story.mapIconName);
			if (svgLookup) {
				svg = svgLookup;
			}
			let svgSize = 40;
			if (MobileHelpers.isBelowMd()) {
				svgSize = 25;
			}
			const markerOptions: google.maps.MarkerOptions = {
				map: this.map,
				draggable: false,
				position: markerPosition,
				icon: {				
					anchor: new google.maps.Point(0,0),
					scaledSize: new google.maps.Size(svgSize, svgSize),
					url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)
				}				
			};

			const marker = new google.maps.Marker(markerOptions);

			const selectDealer = () => {
				this.infoWindow.setContent(this.createInfoWindowContent(story, index + 1));
				this.infoWindow.open(this.map, marker);
				if (!this.map.getBounds().contains(markerPosition)) {
					this.map.setCenter(markerPosition);
				}
			};

			marker.addListener("click", selectDealer);
			this.markers.push(marker);
		}

		const renderer: Renderer = {
			render: ({count, position}) => {
				// change color if this cluster has more markers than the mean cluster
				let color = "#1f275d\n";
				
				if (SiteHelpers.isGeopier()) {
					color = "#1f275d";
				}

				// create svg url with fill color
				const svg = window.btoa(`
				<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
				  <circle cx="120" cy="120" opacity=".8" r="70" />
				  <circle cx="120" cy="120" opacity=".6" r="90" />				 
				</svg>`);

				// create marker using svg icon
				return new google.maps.Marker({
					position,
					icon: {
						url: `data:image/svg+xml;base64,${svg}`,
						scaledSize: new google.maps.Size(40, 40),
					},
					label: {
						text: String(count),
						color: "rgba(255,255,255,0.9)",
						fontSize: "12px",
					},
					// adjust zIndex to be above other markers
					zIndex: 1000 + count,
				});
			}
		};

		const markerClusterOptions: MarkerClustererOptions = {
			map: this.map,
			markers: this.markers,
			renderer: renderer
		}

		this.markerCluster = new MarkerClusterer(markerClusterOptions);

		this.map.fitBounds(bounds);

		const currentZoom = this.map.getZoom();
		if (currentZoom > 6) {
			this.map.setZoom(6);
		}


	}
	
	private hideSearchAreaButton() {
		
	}

	private showSearchAreaButton() {
		
	}

	private clearResults(): void {

		for (const marker of this.markers) {
			marker.setMap(null);
			google.maps.event.clearInstanceListeners(marker);
		}
		this.markerCluster?.clearMarkers();
		this.markers = [];
		
	}
	
	private createInfoWindowContent(story: SuccessStory, number: number) : string {
		const cleanImageUrl = story.image?.replace("~", "");
		let imageElement = "<span class='no-image'></span>";
		if (cleanImageUrl) {
			imageElement = `<img src="${cleanImageUrl}" alt="${story.title}" />`;
		}
		const detailUrl =story.detailUrl.replace('~','');
		return `<div class="card-info-window">
					<div class="image"><a href="${detailUrl}">${imageElement}</a></div>
					<div class="content">
					<h2><a href="${detailUrl}">${story.title}</a></h2>
					${story.summary}
					</div>
				</div>
		`;
	}

	
}

